exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expandableContainer{border-style:solid;border-color:#e6e6e6;border-radius:15px;border-width:2px}", ""]);

// exports
